export default __webpack_public_path__ + "static/media/gallery_05.1b90f952.jpg";